// extracted by mini-css-extract-plugin
export default {"toggleItemDefault":"ToggleItem_toggleItemDefault__5884I","label":"ToggleItem_label__Duam1","toggleItemSelected":"ToggleItem_toggleItemSelected__Gg+2W"};